import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DailyFeedbackReportsDataService } from "../../services/daily-feedback-reports-data.service";
import { DailyFeedbackReportsAggregationDataService } from "../../services/daily-feedback-reports-aggregation-data.service";
import { headerColumns } from "../../configs/daily-feedback-reports-header-config";
import { DailyFeedbackReportsRowComponent } from "../daily-feedback-reports-row/daily-feedback-reports-row.component";

@Component({
  selector: 'app-daily-feedback-reports-page-content',
  standalone: true,
  templateUrl: './daily-feedback-reports-page-content.component.html',
  styleUrl: './daily-feedback-reports-page-content.component.scss',
  imports: [
    DailyFeedbackReportsRowComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DailyFeedbackReportsPageContentComponent {
  groupStyles = input<Record<string, string>>({});

  public dailyFeedbackReportsDataService: DailyFeedbackReportsDataService = inject(DailyFeedbackReportsDataService);
  public dailyFeedbackReportsAggregationDataService: DailyFeedbackReportsAggregationDataService = inject(DailyFeedbackReportsAggregationDataService);

  public readonly headerColumns = headerColumns;
  public dailyFeedbackReportsAggregationData = computed(() =>
    this.dailyFeedbackReportsAggregationDataService.dailyFeedbackReportsAggregationData()
  );
  public dailyFeedbackReportsData = computed(() =>
    this.dailyFeedbackReportsDataService.dailyFeedbackReportsData()
  );
  public dailyFeedbackReportsDataCount = computed(() =>
    this.dailyFeedbackReportsData().length
  );
}
